import React from 'react';
import Button from '../Button/Button';
import './ValidationPopUp.css';

interface ValidationPopUpProps {
  title: string;
  text: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  cancelLabel?: string;
  confirmLabel?: string;
  children?: React.ReactNode;
  icon?: React.ReactNode; // Icône optionnelle affichée au-dessus du titre
  isLoading?: boolean;
}

const ValidationPopUp: React.FC<ValidationPopUpProps> = ({
  isOpen,
  title,
  text,
  onClose,
  onConfirm,
  cancelLabel,
  confirmLabel,
  children,
  icon,
  isLoading = false
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className={`modal-content${icon ? ' modal-content--with-icon' : ''}`}>
        {icon && <div className="modal-icon">{icon}</div>}
        <h2>{title}</h2>
        {text && <p className="modal-text">{text}</p>}

        {children && <div className="modal-custom-content">{children}</div>}

        <div className="modal-actions">
          {cancelLabel && (
            <Button
              value={cancelLabel}
              variant="secondary"
              onClick={onClose}
              disabled={isLoading}
            />
          )}
          {confirmLabel && (
            <Button
              value={isLoading ? <span className="vp-spinner" role="status" aria-label="Chargement" /> : confirmLabel}
              variant="primary"
              onClick={onConfirm}
              disabled={isLoading}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ValidationPopUp;